import { LotEventTypes } from '@parallel-fluidics/shared/constants';
import { lotEventToFirestore } from '@parallel-fluidics/shared/models/lots';
import {
  addDoc,
  collection,
  getFirestore,
  serverTimestamp,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Print a pre-rendered lot label (base64 PNG from `renderLotLabel`) on the
 * chosen label station (`printer` id from the shared LabelPrinters registry)
 * via the printLabelImageV2 callable, then log a `label_printed` event.
 * Throws (without logging the event) only when printing fails — the event
 * write is best-effort, so a failed audit log can't make a successfully
 * printed label look failed and trigger a duplicate print.
 */
export default async function printLotLabel({
  lotId,
  image,
  printer,
  user,
}) {
  const printLabelImage = httpsCallable(getFunctions(), 'printLabelImageV2');
  await printLabelImage({ image, printer });

  try {
    await addDoc(
      collection(getFirestore(), 'lots', lotId, 'events'),
      lotEventToFirestore({ type: LotEventTypes.LABEL_PRINTED, _createdBy: user }, serverTimestamp),
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Label printed but the label_printed event failed to log:', error);
  }
}
